export const updateAuthSSOBasedJourneyReducer = {
  updateAuthSSOBasedJourney: (state, action) => {
    state.ssoBasedJourney = action.payload;
  },
};
